import { Navigate, Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAppSelector } from './hooks/redux';
import LoginPage from './pages/Login';
import SupportShell from './components/SupportShell';
import AiMonitor from './pages/AiMonitor';
import CompanyAi from './pages/CompanyAi';
import PromptLab from './pages/PromptLab';
import Smith from './pages/Smith';
import SmithTrace from './pages/SmithTrace';

function RequireStaff({ children }: { children: ReactNode }) {
  const { token, user } = useAppSelector((s) => s.auth);
  if (!token || user?.role !== 'ADMIN') return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireStaff>
            <SupportShell />
          </RequireStaff>
        }
      >
        <Route path="/" element={<AiMonitor />} />
        <Route path="/smith" element={<Smith />} />
        <Route path="/smith/:id" element={<SmithTrace />} />
        <Route path="/prompts" element={<PromptLab />} />
        <Route path="/companies/:id" element={<CompanyAi />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
